<template>
  <PostArticle
    v-if="news && Object.keys(news).length"
    link="News"
    :post-data="news"
    type="News"
  ></PostArticle>
</template>

<script setup lang="ts">
import { dataLoaded, useHandleError, useMetaData } from '@/composables/Common.js';
import { newsPostQuery } from '@/queries/GetNewsPost';
import PostArticle from '@/components/common/PostArticle.vue';
import { ref } from 'vue';
import { useQuery } from 'villus';

const props = defineProps<{
  slug: string;
}>();

const { handleError } = useHandleError();
const { setMetaDescription, setMetaTitle } = useMetaData();

const news = ref({});

const { data } = useQuery({
  onData: data => {
    if (data.news && Object.keys(data.news).length) {
      news.value = data.news;
      setMetaTitle(data.news.title);
      setMetaDescription(data.news.excerpt);
      dataLoaded();
    }

    if (!data.news || Object.keys(data.news).length === 0) {
      handleError('NewsPost', props.slug);
    }
  },
  query: newsPostQuery,
  variables: { slug: props.slug },
});
</script>

<script lang="ts">
export default {
  beforeRoute(params, villusClient) {
    return new Promise<void>((resolve, reject) => {
      villusClient
        .executeQuery({
          query: newsPostQuery,
          variables: { slug: params.slug },
        })
        .then(() => resolve())
        .catch((err) => reject(err));
    });
  },
};
</script>
